(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'applyOverview', {
            bindings: {
                content:       '<'
            },
            templateUrl:  'app/views/partials/content/apply-overview.html',
            controller:   ApplyOverviewController,
            controllerAs: 'vm',

            renderingOptions: {
                /** @type {RecipeConfig} */
                'postgrad-apply': {
                    inputs:    [
                        'content="::content.asset_contents.content"'
                    ],
                    classes:       [
                        'block',
                        'detail-overview'
                    ],
                    wrapStart:     '<div class="centraliser">',
                    wrapEnd:       '</div>'
                }
            },

            renderingOptionsOverrides: {
                nested: {
                    /** @type {RecipeConfig} */
                    'postgrad-apply': {
                        wrapStart:     null,
                        wrapEnd:       null,
                        parentClasses: [
                            'block',
                            'detail-overview'
                        ],
                        classes: []
                    }
                }
            }
        });


    /**
     * @type {ng.IController}
     *
     * @param {ng.IScope} $scope
     * @param {ContentSwitchingService} ContentSwitchingService
     * @param {LoggerService} LoggerFactory
     * @param {Object} TEXTS
     */
    function ApplyOverviewController(
        $scope,
        ContentSwitchingService,
        LoggerFactory,
        TEXTS
    ){
        // Helping members.

        /** @type {ng.IController} */
        var vm = this;

        /** @type {Logger} */
        //var logger = LoggerFactory.createLogger( 'ApplyOverviewController', false );



        /** @const */
        var INTERNATIONAL_API_CODE_ATTRIBUTE = 'internationalApiCode',
        _ = TEXTS.POSTGRAD.APPLY_OVERVIEW;



        /** Expose to the $scope. */

        $scope._ = _;



        /** Expose to the Controller */

        // Methods
        vm.setFeesVisibility = function( feesVisibilityFlag ) {
            vm.areFeesVisible = feesVisibilityFlag;
            renderHeadingText();
        };



        /** @constructor */
        vm.$onInit = function() {
            setWatchers();
            renderHeadingText();
        };



        /** Private function */

        // Set watchers
        function setWatchers() {
            $scope.$watch( 'ContentSwitchingService.contentType', function() {
                vm.isInternationalContent = ContentSwitchingService.isInternational();
            });
        }



     function renderHeadingText() {
            var headingText = "",

            areKeyDatesOn = vm.content.keyDatesSet,
            areFeesOn = !(!vm.areFeesVisible && !vm.isInternationalContent) && vm.content.fees;

            if (areKeyDatesOn) headingText += _.HEADING_DATES;
            if (areKeyDatesOn && areFeesOn) headingText += " and ";
            if (areFeesOn) headingText += _.HEADING_FEES;

            // Make the first letter always capital
            vm.headingText = headingText && headingText[0].toUpperCase() + headingText.slice(1);
        }
    }


    ApplyOverviewController.$inject = [ '$scope', 'ContentSwitchingService', 'LoggerFactory', 'TEXTS' ];
})();
